import Head from 'next/head';
import { Footer, Header } from '../../components';
import menu from '../../utils/menu';
import previewMain from '../../public/preview/preview-main.png';
import ContactPage from './contact-page';

export default function Contact() {
  return (
    <>
      <Head>
        <title>Mavinx: Expert Solutions and Collaborative Partnerships</title>
        <meta
          property="og:title"
          content="Mavinx: Expert Solutions and Collaborative Partnerships"
        />
        <meta property="og:image" content={`${previewMain.src}`} />
        <meta name="twitter:image" content={`${previewMain.src}`} />
        <meta
          property="og:image:alt"
          content="Mavinx: Expert Solutions and Collaborative Partnerships"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Contact Mavinx to discuss custom solutions and collaborations with our specialists. Our skilled staff are available to help with questions, project suggestions, or company requirements. Mavinx can assist with online and mobile app development, software solutions, digital marketing, and more. Personal attention, trustworthy assistance, and creative solutions to grow your company. Contact Mavinx now and let's succeed together."
        />
        <meta
          name="description"
          content="Contact Mavinx to discuss custom solutions and collaborations with our specialists. Our skilled staff are available to help with questions, project suggestions, or company requirements. Mavinx can assist with online and mobile app development, software solutions, digital marketing, and more. Personal attention, trustworthy assistance, and creative solutions to grow your company. Contact Mavinx now and let's succeed together."
        />
        <meta
          name="keywords"
          content="contact Mavinx, get in touch, expert solutions, collaborative partnerships, inquiries, project proposals, business needs, web development, mobile app development, software solutions, digital marketing, personalized attention, reliable support, innovative solutions, business growth, Mavinx contact, collaborative journey"
        />
      </Head>
      <Header appearance="transparent" appearanceLogo="primary" menu={menu} />
      <ContactPage />
      <Footer />
    </>
  );
}
